const TableLayout = (props) => {
  return (
    <div className="table-responsive tbl-fixed-header tbl-main" {...props}>
      {props.children}
    </div>
  );
};

export default TableLayout;
